import { DefaultButton } from './Button'
import { DefaultInput } from './Input'
import { DefaultTextArea } from './TextArea'

export const Defaults = {
  Button: DefaultButton,
  Input: DefaultInput,
  TextArea: DefaultTextArea
}
